import Appointments from "@/components/management/Appointments";
import CreateAppointment from "@/components/management/components/appointment/CreateAppointmentForm";

const AppointmentRoutes = [
  { path: "/appointments", element: <Appointments /> },
  { path: "/appointments/create", element: <CreateAppointment /> },
];

export default AppointmentRoutes;
